<template>
    <div>
        <!-- Modal Compartilhamento -->
        <div class="modal fade" id="compartilharLaudoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Compartilhar Laudo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="laudo">
                            <div class="lead">{{ laudo.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                            <div>{{ laudo.atendimento_procedimento.procedimento.search }}</div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Compartilhar com..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsName="medicos-lista-atend"
                                    :optionsParm="{ ativos: true, atendimento: true }"
                                    optionsData="id_pessoa"
                                    v-model="id_medico"
                                    required
                                    :validate="validate" />
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    type="textarea"
                                    rows="3"
                                    v-model="descricao" 
                                    label="Descrição" 
                                    required
                                    :validate="validate"
                                    placeholder="Descrição" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            descricao: '',
            id_medico: '',
            validate: false, 
            id_laudo: null, 
            laudo: null, 
        }
    },

    components: {
        AzInput,
        AzSubmit, 
    },

    methods: {
        abrir(laudo) {
            this.id_laudo = laudo.id_laudo;
            this.validate = false;
            this.descricao = "";
            this.id_medico = ""; 
            this.laudo = _.cloneDeep(laudo);

            $('#compartilharLaudoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'compartilhar_via_tarefa', 
                dados: { 
                    id_laudo: this.id_laudo, 
                    medico: this.id_medico, 
                    descricao: this.descricao, 
                }, 
                modal: 'compartilharLaudoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },
    }
}
</script>
